module.exports = __webpack_public_path__ + "img/tr-logo.ea4b0d5e.png";